import {
  InsightsCombinedItemDto,
  InsightsCombinedItemModel,
  mapInsightsItemDtoToModel,
} from './InsightsCombined/InsightsItem.dto';

export type InsightsCombinedDto = Readonly<{
  questions: ReadonlyArray<InsightsCombinedItemDto>;
}>;

export type InsightsCombinedModel = Readonly<{
  questions: ReadonlyArray<InsightsCombinedItemModel>;
}>;

export const mapInsightsCombinedDtoToModel = (dto: InsightsCombinedDto): InsightsCombinedModel => ({
  questions: dto.questions.map((insight) => mapInsightsItemDtoToModel(insight)),
});
